import { combineReducers } from '@reduxjs/toolkit';
import { TABS_STATE_NAMESPACE, tabsReducer } from '@che-ins-ui/tabs';
import { modalReducer, MODAL_STATE_NAMESPACE } from '@che-ins-ui/modal';
import { phoneInputReducer, PHONE_INPUT_NAMESPACE, } from '@che-ins-ui/phone-input';
import { PROCESS_STATE_NAMESPACE, processReducer } from './process/index';
import { FORMS_STATE_NAMESPACE, formsReducer } from './forms';
import { FLIGHTS_STATE_NAMESPACE, flightsReducer } from './flights';
import { THEME_STATE_NAMESPACE, themeReducer } from './theme';
import { STEPS_STATE_NAMESPACE, stepsReducer } from './steps';
import { MARKETING_STATE_NAMESPACE, marketingReducer } from './marketing';
const rootReducer = combineReducers({
    [PROCESS_STATE_NAMESPACE]: processReducer,
    [MARKETING_STATE_NAMESPACE]: marketingReducer,
    [MODAL_STATE_NAMESPACE]: modalReducer,
    [FORMS_STATE_NAMESPACE]: formsReducer,
    [TABS_STATE_NAMESPACE]: tabsReducer,
    [PHONE_INPUT_NAMESPACE]: phoneInputReducer,
    [THEME_STATE_NAMESPACE]: themeReducer,
    [STEPS_STATE_NAMESPACE]: stepsReducer,
    [FLIGHTS_STATE_NAMESPACE]: flightsReducer,
});
export default rootReducer;
